import { Navigate } from "react-router-dom";
import WelcomePage from "@screen/Welcome";
import LoginPage from "@screen/Login";
import PageWrapper from "@screen/Home/PageWrapper";
import WaitingArrangementGate from "@components/WaitingArrangementGate";
import HomePage from "@screen/Home/pages/HomePage";
import OrderList from "@screen/Home/pages/OrderList";
import OrderDetail from "@screen/Home/pages/OrderList/orderDetail";
import PayOrder from "@screen/Home/pages/Pay";
import Iot from "@screen/Home/pages/IoTDevice";
import Account from "@screen/Home/pages/Account";
import Coupons from "@screen/Home/pages/Account/coupon";
import Wallet from "@screen/Home/pages/Account/wallet";
import TransDetail from "@screen/Home/pages/Account/transDetail";
import TransAll from "@screen/Home/pages/Account/transAll";
import TopUp from "@screen/Home/pages/Account/topUp";

import RegisterPageRoutes from "@screen/Register";
import InvitedCode from "@screen/Register/pages/InvitedCode";
import Step3 from "@screen/Register/pages/profile";
import JoinByInvite from "@screen/Register/pages/joinByInvite";
import NewUserRegister from "@screen/Register/pages/newUser";
import ExistingCustomer from "@screen/Register/pages/existingCustomer";
import QuickOrder from "@screen/QuickOrder";
import KioskHome from "@screen/Kiosk";
import KioskCart from "@screen/Kiosk/cart";
import KioskConfirm from "@screen/Kiosk/confirm";
import KioskAddCard from "@screen/Kiosk/AddCard";
import KioskJoin from "@screen/Kiosk/join";
import KioskSuccess from "@screen/Kiosk/success";
import DraftList from "@screen/QuickOrder/pages/DraftList";
import QuickOrderDeliveryOnly from "@screen/QuickOrder/pages/QuickOrderDeliveryOnly";
import GasShopProducts from "@screen/Home/pages/GasShop/products";
import GasShopInstallPosition from "@screen/Home/pages/GasShop/installPosition";
import GasShopCart from "@screen/Home/pages/GasShop/cart";
import GasShopOrderDone from "@screen/Home/pages/GasShop/orderDone";
import GasShopDeliveryTime from "@screen/Home/pages/GasShop/deliveryTime";
import GasShopPayment from "@screen/Home/pages/GasShop/payment";
import VerifyPhone from "@screen/Register/pages/verifyPhone";
import Onboarding from "@screen/Onboarding";
import SmsInviteLanding from "@screen/SmsInvite";
import SmsInviteOpen from "@screen/SmsInviteOpen";
import PracticeEntry from "@screen/Training";
import LineNotice from "@screen/Training/LineNotice";
import Developing from "@screen/Developing";
import { GasShopStation } from "@screen/Home/pages/GasShop/station";
import AddAccount from "@screen/Home/pages/Account/addAccount";
import PaymentMethod from "@screen/Home/pages/Account/paymentMethod";
import PaymentResult from "@screen/Home/pages/Account/components/paymentMethod/PaymentResult";
import Bind3dsLanding from "@screen/Home/pages/Account/components/paymentMethod/Bind3dsLanding";
import PaymentMethodDetail from "@screen/Home/pages/Account/components/paymentMethod/PaymentMethodDetail";
import CardPaymentsAll from "@screen/Home/pages/Account/components/paymentMethod/CardPaymentsAll";
import PayRecord from "@screen/Home/pages/Account/payRecord";
import PayRecordDetail from "@screen/Home/pages/Account/payRecordDetail";
import AccountDetail from "@screen/Home/pages/Account/accountDetail";
import Pricing from "@screen/Home/pages/Account/pricing";
import InviteMember from "@screen/Home/pages/Account/inviteMember";
import InviteEntry from "@screen/Home/pages/Account/inviteEntry";
import AddressEdit from "@screen/Home/pages/Account/addressEdit";
import AccountSettings from "@screen/Home/pages/Account/accountSettings";
import MemberPermissions from "@screen/Home/pages/Account/memberPermissions";
import AccountPayments from "@screen/Home/pages/Account/accountPayments";
import AccountOrderHistory from "@screen/Home/pages/Account/accountOrderHistory";
import AccountPaymentRecords from "@screen/Home/pages/Account/accountPaymentRecords";
import PointsDetail from "@screen/Home/pages/Account/pointsDetail";
import SurveyPage from "@screen/Survey";

/** 練習專用部署（REACT_APP_PRACTICE_ONLY=1）：根路徑直接進練習 Hub，
 *  不走歡迎頁 / LINE 登入導頁（練習模式下 provider 已注入假 token）。 */
const PRACTICE_ONLY = process.env.REACT_APP_PRACTICE_ONLY === "1";

export const routeConfig = [
  {
    path: "/",
    element: PRACTICE_ONLY ? <Navigate to="/practice" replace /> : <WelcomePage />,
  },
  /** 歡迎頁預覽用路由：`/` 在 LIFF/skip-LIFF 流程會被 LineLoginProvider 自動導頁，
   *  此路由不受影響，方便直接預覽歡迎頁畫面。 */
  { path: "/welcome", element: <WelcomePage /> },
  { path: "/login", element: <LoginPage /> },
  /** 由路徑分入口的落地頁（掃鋼瓶 QR / 傳單），供各入口未來各自綁定 LIFF endpoint：
   *  /onboarding/qr?supplier=&scan={0|1}&code=  或  /onboarding/flyer?supplier=
   *  無參數（/onboarding）顯示中性提示（請由 QR / 傳單連結進入）；註冊完成/既有客戶皆導向現有 /kiosk 一鍵下單。
   *  舊版 ?src=qr|flyer query 仍相容（parseEntry fallback），避免已印出去的連結失效。 */
  { path: "/onboarding", element: <Onboarding /> },
  /** 簡訊邀請落地頁：LIFF 連結帶 phone / invite / order_id，靜默註冊登入後直達訂單詳情。
   *  獨立路由、無底部 tab bar（不進 PageWrapper），全程只顯示 loading。 */
  { path: "/sms-invite", element: <SmsInviteLanding /> },
  /** 簡訊邀請中繼頁：簡訊只能放自有網域（電信擋 liff.line.me），本頁把客戶帶進
   *  瓦斯行自己的 LIFF（liff.line.me/{liffId}/sms-invite）。不初始化 LIFF（provider 旁路）。 */
  { path: "/sms-invite/open", element: <SmsInviteOpen /> },
  { path: "/onboarding/qr", element: <Onboarding /> },
  { path: "/onboarding/flyer", element: <Onboarding /> },
  /** 客服練習模式入口（教學沙盒）：/practice 選單；/practice/<情境> 直接進該情境；?done=xxx 完成頁 */
  { path: "/practice", element: <PracticeEntry /> },
  { path: "/practice/:scenario", element: <PracticeEntry /> },
  /** 「即將到期通知下單」情境的模擬 LINE 聊天室（獨立路由，避免被 /practice/:scenario 當成情境 slug）。 */
  { path: "/practice-notice", element: <LineNotice /> },
  {
    element: <PageWrapper />,
    children: [
      { path: "/home", element: <HomePage /> },
      {
        // 等待安排瓦斯行（waiting list）→ 首頁/完成設定照常，「瓦斯訂購」對接完成前鎖定（灰化＋遮罩）
        path: "/gasShop",
        children: [
          {
            path: "/gasShop/stations",
            element: <WaitingArrangementGate><GasShopStation /></WaitingArrangementGate>,
          },
          {
            path: "/gasShop/products",
            element: <WaitingArrangementGate><GasShopProducts /></WaitingArrangementGate>,
          },
          {
            path: "/gasShop/installPosition",
            element: <WaitingArrangementGate><GasShopInstallPosition /></WaitingArrangementGate>,
          },
          {
            path: "/gasShop/deliveryTime",
            element: <WaitingArrangementGate><GasShopDeliveryTime /></WaitingArrangementGate>,
          },
          {
            // 付款方式（配送時間 → 付款方式 → 確認訂單）；只在瓦斯行開啟電子付款時進來
            path: "/gasShop/payment",
            element: <WaitingArrangementGate><GasShopPayment /></WaitingArrangementGate>,
          },
          {
            path: "/gasShop/cart",
            element: <WaitingArrangementGate><GasShopCart /></WaitingArrangementGate>,
          },
          {
            // 下單成功頁（流程終點）。orderId 走 navigate state，路徑保持固定字串
            path: "/gasShop/done",
            element: <GasShopOrderDone />,
          },
        ],
      },
      { path: "/orders", element: <OrderList /> },
      { path: "/orders/:orderId", element: <OrderDetail /> },
      { path: "/pay/:orderId", element: <PayOrder /> },
      { path: "/iot", element: <Iot /> },
      { path: "/account", element: <Account /> },
      { path: "/account/coupons", element: <Coupons /> },
      { path: "/account/wallet", element: <Wallet /> },
      {
        path: "/account/paymentMethod",
        children: [
          { index: true, element: <PaymentMethod /> },
          { path: "result", element: <PaymentResult /> },
        ],
      },
      { path: "/account/addAccount", element: <AddAccount /> },
    ],
  },
  { path: "/account/wallet/transDetail/:transId", element: <TransDetail /> },
  { path: "/account/wallet/transAll", element: <TransAll /> },
  { path: "/account/wallet/topUp", element: <TopUp /> },
  { path: "/account/payRecord", element: <PayRecord /> },
  { path: "/account/payRecord/:paymentId", element: <PayRecordDetail /> },
  /** 3DS challenge 落地頁：TapPay `frontend_redirect_url` 導回目標（§6）。獨立路由，無底部 tab bar，全程輪詢畫面。 */
  { path: "/account/paymentMethod/bind-3ds", element: <Bind3dsLanding /> },
  { path: "/account/paymentMethod/detail/:methodId", element: <PaymentMethodDetail /> },
  { path: "/account/paymentMethod/detail/:methodId/payments", element: <CardPaymentsAll /> },
  { path: "/account/invite", element: <InviteEntry /> },
  { path: "/account/detail/:contextId", element: <AccountDetail /> },
  { path: "/account/detail/:contextId/pricing", element: <Pricing /> },
  { path: "/account/detail/:contextId/invite", element: <InviteMember /> },
  { path: "/account/detail/:contextId/settings", element: <AccountSettings /> },
  { path: "/account/detail/:contextId/members", element: <MemberPermissions /> },
  { path: "/account/detail/:contextId/payments", element: <AccountPayments /> },
  { path: "/account/detail/:contextId/orders", element: <AccountOrderHistory /> },
  { path: "/account/detail/:contextId/payment-records", element: <AccountPaymentRecords /> },
  // 存氣點數 / 帳戶點數各一頁（kind = stored-gas | account）；
  // 不帶 kind 的舊連結由 PointsDetail 轉回帳戶頁。
  { path: "/account/detail/:contextId/points/:kind", element: <PointsDetail /> },
  { path: "/account/detail/:contextId/points", element: <PointsDetail /> },
  { path: "/account/detail/:contextId/address/new", element: <AddressEdit /> },
  { path: "/account/detail/:contextId/address/:addressId", element: <AddressEdit /> },
  {
    path: "/register",
    element: <RegisterPageRoutes />,
    children: [
      { path: "/register/step2/inviteCode", element: <InvitedCode /> },
      { path: "/register/verifyPhone", element: <VerifyPhone /> },
      { path: "/register/profile", element: <Step3 /> },
    ],
  },
  /** 零表單邀請註冊：掃家庭邀請碼 QR 未註冊者落地，僅手機 OTP 即完成註冊+加入家庭。
   *  獨立路由（不走 /register 的 4 步驟 wrapper）。 */
  { path: "/register/join", element: <JoinByInvite /> },
  /** 用氣習慣問卷（冷啟動 onboarding，全屏獨立頁） */
  { path: "/survey", element: <SurveyPage /> },
  /** 新用戶自動配對註冊：手機 OTP → 依手機/地址配對瓦斯行 → 推薦/候補 → 線上簽約 → 完成。
   *  單頁狀態機，獨立路由（不走 /register 的步驟 wrapper）。配對/推薦/簽約目前為 mock。 */
  { path: "/register/new", element: <NewUserRegister /> },
  /** 既有客戶入口：選擇有序號（→序號註冊）或沒序號（→自動配對 /register/new）。 */
  { path: "/register/existing", element: <ExistingCustomer /> },
  /** 點餐機式下單流程（v2，並行於舊 /gasShop，保留舊流程不動）。
   *  等待安排瓦斯行的客戶同樣鎖定（gate 對「QR 掃碼進來、已有目標瓦斯行」的 session 放行，
   *  讓客戶能走完 完成設定 → 建 CIS 自行解套）。 */
  { path: "/kiosk", element: <WaitingArrangementGate><KioskHome /></WaitingArrangementGate> },
  { path: "/kiosk/cart", element: <WaitingArrangementGate><KioskCart /></WaitingArrangementGate> },
  { path: "/kiosk/join", element: <WaitingArrangementGate><KioskJoin /></WaitingArrangementGate> },
  { path: "/kiosk/confirm", element: <WaitingArrangementGate><KioskConfirm /></WaitingArrangementGate> },
  { path: "/kiosk/add-card", element: <WaitingArrangementGate><KioskAddCard /></WaitingArrangementGate> },
  { path: "/kiosk/success", element: <WaitingArrangementGate><KioskSuccess /></WaitingArrangementGate> },
  {
    path: "/quickOrder",
    element: <QuickOrder />,
  },
  {
    path: "/quickOrder/drafts",
    element: <DraftList />,
  },
  {
    path: "/quickOrder/:draftId/delivery",
    element: <QuickOrderDeliveryOnly />,
  },
  {
    path: "/quickOrder/:orderID",
    element: <QuickOrder />,
  },
  /** 修改訂單且直接送出（不進三步驟確認）：路徑型 endpoint，與 ?skip_confirm=1 同義 */
  {
    path: "/quickOrder/:orderID/skip_confirm",
    element: <QuickOrder />,
  },
  {
    path: "*",
    element: <Developing />,
  },
];
